import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import { applyTheme } from '@platform-ui/styles/applyTheme.js';
import useMUItheme from '@platform-ui/styles/material.theme.js';
import { ReactNode, useEffect } from 'react';

function getFaviconEl(): HTMLElement {
  return document.getElementById('favicon');
}

export default function ThemeProvider({ children }: { children: ReactNode }): JSX.Element {
  const partner = usePartner();
  const theme = useMUItheme(partner);

  useEffect(() => {
    if (partner) {
      const {
        whitelabeling: { favicon: partnerFavicon, platformName, brandColor },
      } = partner;

      const favicon = getFaviconEl();
      if (favicon && partnerFavicon) {
        favicon.setAttribute('href', partnerFavicon);
      } else if (favicon) {
        favicon.setAttribute('href', '/assets/beam_favicon.ico');
      }

      applyTheme({ brand: brandColor });
    }
  }, [partner]);

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
